import React from 'react';
import { ChevronRightIcon, HomeIcon } from 'lucide-react';
interface PageBannerProps {
  title: string;
  subtitle?: string;
  breadcrumbs: {
    label: string;
    path: string;
  }[];
}
export function PageBanner({
  title,
  subtitle,
  breadcrumbs
}: PageBannerProps) {
  return <div className="relative pt-32 pb-20 overflow-hidden bg-gradient-to-br from-primary-dark via-primary to-primary-light" data-id="element-275">
      {/* Abstract pattern overlay for texture */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#ffffff 1px, transparent 1px)',
      backgroundSize: '30px 30px'
    }} data-id="element-276"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-277">
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-278">
          {title}
        </h1>
        {subtitle && <p className="text-xl text-white/90 max-w-2xl mx-auto mb-8" data-id="element-279">
            {subtitle}
          </p>}

        <nav className="flex justify-center" aria-label="Breadcrumb" data-id="element-280">
          <ol className="inline-flex items-center space-x-1 md:space-x-3 bg-white/10 backdrop-blur-sm px-6 py-2 rounded-full border border-white/20" data-id="element-281">
            <li className="inline-flex items-center" data-id="element-282">
              <a href="#/" className="inline-flex items-center text-sm font-medium text-white/80 hover:text-white transition-colors" data-id="element-283">
                <HomeIcon className="w-4 h-4 mr-2" data-id="element-284" />
                Home
              </a>
            </li>
            {breadcrumbs.map((crumb, index) => <li key={index} data-id="element-285">
                <div className="flex items-center" data-id="element-286">
                  <ChevronRightIcon className="w-4 h-4 text-white/60 mx-1" data-id="element-287" />
                  <a href={`#${crumb.path}`} className={`ml-1 text-sm font-medium transition-colors ${index === breadcrumbs.length - 1 ? 'text-white pointer-events-none' : 'text-white/80 hover:text-white'}`} aria-current={index === breadcrumbs.length - 1 ? 'page' : undefined} data-id="element-288">
                    {crumb.label}
                  </a>
                </div>
              </li>)}
          </ol>
        </nav>
      </div>

      {/* Decorative bottom curve */}
      <div className="absolute bottom-0 left-0 right-0 h-10 bg-light-alt" style={{
      clipPath: 'polygon(0 100%, 100% 100%, 100% 0, 0 100%)'
    }} data-id="element-289"></div>
    </div>;
}